.utility {
  --util-icon: 1.25rem;
  --util-focus-ring: var(--focus-ring);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  background: transparent;
  color: var(--text-disabled);
  cursor: pointer;
  transition:
    background 150ms ease,
    color 150ms ease,
    border-color 150ms ease;
}

.utility:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow: var(--util-focus-ring);
}

.utility:disabled {
  color: var(--border);
  cursor: not-allowed;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--util-icon);
  line-height: 0;
}
.icon > svg {
  width: 1em;
  height: 1em;
}

/* ── Sizes ── */
.size-xs {
  padding: 0.25rem;
}
.size-sm {
  padding: 0.375rem;
}

/* ── Secondary (bordered white) ── */
.secondary {
  --util-focus-ring: var(--focus-ring-shadow-xs);
  background: var(--surface);
  border-color: var(--border);
  box-shadow:
    0 1px 2px 0 rgba(10, 13, 18, 0.05),
    inset 0 -2px 0 0 rgba(10, 13, 18, 0.05),
    inset 0 0 0 1px rgba(10, 13, 18, 0.18);
}
.secondary:hover:not(:disabled) {
  background: var(--surface-secondary);
  color: var(--text-quaternary);
}
.secondary:disabled {
  background: var(--surface);
  border-color: var(--border-light);
  box-shadow: none;
}

/* ── Tertiary (transparent) ── */
.tertiary:hover:not(:disabled) {
  background: var(--surface-secondary);
  color: var(--text-quaternary);
}
